import React, { useState } from "react";
import { Image, Modal } from "react-bootstrap";
import "./ProfileCard.css";

const ProfileCard = ({ el }) => {
    const { name, fb, insta, linkedin, twitter, img, title, bio } = el;
    const [modalShow, setModalShow] = useState(false);
    return (
        <div className="col-lg-4">
            <div className="card p-0">
                <div className="card-image" onClick={() => setModalShow(true)}> <Image src={img} alt="name" fluid /> </div>
                <div className="card-content d-flex flex-column align-items-center">
                    <h4 className="pt-2">{name}</h4>
                    <h5>{title}</h5>
                    <ul className="social-icons d-flex justify-content-center">
                        {fb && <li> <a href={fb} target="_blank" rel="noreferrer"> <span className="fab fa-facebook"></span> </a> </li>}
                        {twitter && <li> <a href={twitter} target="_blank" rel="noreferrer"> <span className="fab fa-twitter"></span> </a> </li>}
                        {insta && <li> <a href={insta} target="_blank" rel="noreferrer"> <span className="fab fa-instagram"></span> </a> </li>}
                        {linkedin && <li> <a href={linkedin} target="_blank" rel="noreferrer"> <span className="fab fa-linkedin-in"></span> </a> </li>}
                    </ul>
                </div>
            </div>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body className="text-center" style={{ backgroundColor: '#0e003f', color: '#37e813' }}>
                    <h4 className="mb-4 border-bottom pb-3">{name}</h4>
                    <p><i>‟{bio}”</i></p>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ProfileCard;
